import _ from 'lodash';
import React from 'react';

import {
  Button,
  styled,
  TextField
} from '@mui/material';

import { useForm } from 'react-hook-form';
import { Search as SearchIcon } from '@mui/icons-material';



const StyledTextField = styled(TextField)(({ theme }) => ({
  backgroundColor: 'rgba(195, 209, 216, 0.25)',
  borderRadius: +theme.shape.borderRadius * 2,
  padding: theme.spacing(1.5),
  marginBottom: theme.spacing(5),
  // These are not recommended, but are required to achieve the custom look present in the design.
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'transparent !important'
  },
  '& .MuiOutlinedInput-root fieldset': {
    border: 'none'
  },
  '& .MuiOutlinedInput-root input': {
    marginLeft: theme.spacing(2)
  }
}));



export interface IProps {
  onChange: (searchText: string) => void;
}

export const FC: React.FC<IProps> = props => {
  const form = useForm<{searchText: string}>({
    defaultValues: {
      searchText: ''
    }
  });

  const watch = form.watch('searchText');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(_.debounce(() => {
    props.onChange(watch);
  }, 2000), [watch]);



  return (
    <form onSubmit={form.handleSubmit(data => {
      props.onChange(data.searchText);
    })}>
      <StyledTextField
        {...form.register('searchText')}
        fullWidth
        variant="outlined"
        placeholder='Search by investor'
        InputProps={{
          startAdornment: (
            <SearchIcon style={{ color: '#87ACB9' }} />
          ),
          endAdornment: (
            <Button type="submit">Search</Button>
          )
        }} />
    </form>

  );
};
